import { useIsMobile } from './useMediaQuery';

/**
 * На телефоне элементы управления не меньше 44px по высоте (docs/10-design.md).
 * В дизайн-системе ближайший размер сверху — lg, это 48px.
 */
export function useControlSize(): 'md' | 'lg' {
  return useIsMobile() ? 'lg' : 'md';
}

export function useIconButtonSize(): 'sm' | 'md' | 'lg' {
  return useIsMobile() ? 'lg' : 'md';
}
